import React, { useEffect, useRef, useState } from 'react';
import { fontActionMini } from '../../styles/typographyNew';
import { classNames } from '../../utils/style';
import { Tab } from './Tab';

const blurImageUrlLeft =
  "before:content-[url('https://payfit.com/icon/blurry-white.svg')]";
const blurImageUrlRight =
  "after:content-[url('https://payfit.com/icon/blurry-white.svg')]";

export const MenuTabs = ({
  selectedIndex,
  cards,
  componentRef,
  setSelectedIndex,
}: any) => {
  const [isBlurryLeft, setIsBlurryLeft] = useState(false);
  const [isBlurryRight, setIsBlurryRight] = useState(false);
  const tabsRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    const currentTabsRef = tabsRef.current;
    const scrollWidth = currentTabsRef?.scrollWidth || 0;
    const width = currentTabsRef?.clientWidth || 0;

    if (currentTabsRef?.scrollLeft !== 0) setIsBlurryLeft(true);
    else setIsBlurryLeft(false);
    if ((currentTabsRef?.scrollLeft || 0) < scrollWidth - width - 10)
      setIsBlurryRight(true);
    else setIsBlurryRight(false);
  };

  useEffect(() => {
    window.addEventListener('resize', handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <div
      ref={tabsRef}
      className={classNames(
        'flex gap-3 md:gap-[16px] overflow-auto bg-white ',
        isBlurryLeft && blurImageUrlLeft,
        isBlurryRight && blurImageUrlRight,
        'before:w-[77px] after:w-[77px] before:absolute after:absolute',
        'before:z-10 after:z-10 before:rotate-180',
        'before:top-0 after:top-0 before:-left-[1px] after:-right-[1px]',
        'pb-3 p-16 md:pb-16',
      )}
      style={{
        justifyContent: !isBlurryLeft && !isBlurryRight ? 'center' : undefined,
      }}
      onScroll={handleScroll}
    >
      {cards?.map(({ ...item }, i) => (
        <Tab
          title={item.tabTitle}
          picto={item.tabIcon}
          key={i}
          className={`${fontActionMini} transition-all flex w-fit whitespace-nowrap !h-48 !px-12 !py-16 justify-center items-center gap-8`}
          selected={selectedIndex === i}
          onClick={(e) => {
            (e.target as Element).scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start',
            });
            (componentRef.current as any).scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest',
            });
            setSelectedIndex(i);
            if (item?.onClick) item?.onClick(e);
          }}
        />
      ))}
    </div>
  );
};
